import { Injectable } from 'angular-ts-decorators';

import * as SentryBrowser from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

let dsn = '';

if (!location.hostname.includes('softwearconnect.lc')) {
  // v7
  if (location.hostname.startsWith('www')) {
    dsn = 'https://b8c95af6795343d1a4caaab64ade246b@app.getsentry.com/39813';
  } else {
    //v6
    dsn = 'https://e1a3aa5e605d40739e35aed731f27692@app.getsentry.com/11600';
  }
}

SentryBrowser.init({
  dsn,

  // The replacement is covered by ./webpack.rules.js
  release: 'v25.16.0-10-gddf4b6c',
  integrations: [new Integrations.BrowserTracing()],
});

@Injectable('sentry')
export class Sentry {
  constructor() {
    'ngInject';
  }

  /**
   * Sents user to sentry context
   */
  setUser(user?) {
    SentryBrowser.setUser(user);
  }

  /**
   * Sends message to sentry
   */
  captureMessage(message: string, captureContext?): void {
    SentryBrowser.captureMessage(message, captureContext);
  }

  /**
   * Sends error object to sentry
   */
  captureException(error: Error, captureContext?): void {
    SentryBrowser.captureException(error, captureContext);
  }
}
